const FEATURE_INTRODUCTIONS = Object.freeze({
  saveFilters: Object.freeze({
    name: "SaveFilters",
    introducedDate: "2025-08-21",
    highlightDuration: 60,
    label: "NEW",
  }),
});

export const isFeatureHighlighted = (featureKey) => {
  const feature = FEATURE_INTRODUCTIONS[featureKey];
  if (!feature) {
    return false;
  }

  const [year, month, day] = feature.introducedDate.split("-").map(Number);
  const introduced = new Date(year, month - 1, day);
  const now = new Date();
  const currentDate = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );
  const msPerDay = 1000 * 60 * 60 * 24;
  const daysSinceIntroduction = Math.round(
    (currentDate - introduced) / msPerDay
  );

  return daysSinceIntroduction <= feature.highlightDuration;
};

export const getFeatureHighlightLabel = (featureKey) => {
  const feature = FEATURE_INTRODUCTIONS[featureKey];

  return feature ? feature.label : "";
};

export const getFeatureHighlightStyle = () => {
  return {
    backgroundColor: "#ff6b35",
    color: "white",
    fontSize: "1rem",
    fontWeight: "bold",
    padding: "2px 6px",
    marginLeft: "8px",
    display: "inline-block",
    animation: "toolbox-pulse 2s infinite",
    textAlign: "center",
    verticalAlign: "middle",
    lineHeight: "1.5",
  };
};
